module.exports = __webpack_public_path__ + "static/media/launch_24px.417d3776.svg";